import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import '../App.css';

export default function CustomizeRequestForm(props) {

  return (
    <Container fluid className="text-start mt-3 mt-md-5">
      <Row>
        <Col></Col>
        <Col xs={12} sm={8}>
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Customize RepCaster</Card.Title>
              <p>
                What can we help you setup? 
              </p>
              <Form noValidate className="px-sm-5">

                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    label="Integrate with your shop managment software"
                    name="integration"
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </div>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    label="Send emails from my domain"
                    name="emailDomain"
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </div>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    label="Host feedback form on my own site"
                    name="formHosting"
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </div>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    label="Contact customers over SMS instead of email"
                    name="sms"
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </div>
                <div className="mb-3">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    label="Display reviews on your own site"
                    name="hostReviews"
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </div>

                <Form.Group className="mb-3" controlId="formRequestEmail">
                  Other (Please describe)
                  <Form.Control 
                    as="textarea"
                    type="text" 
                    name="otherRequest" 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formRequestEmail">
                  When is the best time to contact you?
                  <Form.Control 
                    as="textarea"
                    type="text" 
                    name="whenToContact" 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                  />
                </Form.Group>
          </Form>
            </Card.Body>
          </Card>

        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}
